import React, { useState } from 'react';

import { ReactComponent as HideIcon } from '../../../assets/images/passwordHideIcon.svg';
import { ReactComponent as ShowIcon } from '../../../assets/images/passwordShowIcon.svg';
import CustomTextField from '../CustomTextField/CustomTextField';

const CustomPasswordField = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <CustomTextField
      type={showPassword ? 'text' : 'password'}
      CustomIcon={showPassword ? HideIcon : ShowIcon}
      onIconClick={() => setShowPassword(!showPassword)}
      {...props}
    />
  );
};

export default CustomPasswordField;
